import React from "react"

function DataCard({name, number, image}){
    return(
        <div className="data-card">

       
        <h4 className="card-text">
         <span>{name}</span> 
         <p className="card-num">{number}</p>
         </h4>
        <img src={image} className="card-img" alt="info graph" />
         
        </div>
    )
}

export default DataCard